import React from 'react';

const SINGULAR_DEFINITIONS = {
  exchanges: 'exchange',
  purchases: 'purchase'
};

/**
 * @param {"exchanges" | "purchases"} entity
 * @param {boolean} supportsType
 * @param {boolean} supportsCategory
 */
export function getCopies(entity, supportsType, supportsCategory) {
  const singularTerm = SINGULAR_DEFINITIONS[entity];

  return {
    title: `${singularTerm} catalog`,
    helpText: `Setup your defaults for ${singularTerm} catalog. Choose among the ${
      supportsType ? 'product types,' : ''
    } ${
      supportsCategory ? 'product categories,' : ''
    } collections and exclude products by tags or price.`,
    productTypes: {
      label: 'Product Types',
      description: `Selected product types will appear in catalog during ${singularTerm}.`
    },
    productCategories: {
      label: 'Product Categories',
      description: `Selected product categories will appear in catalog during ${singularTerm}.`
    },
    collections: {
      label: 'Collections',
      description: `Selected collections will appear in catalog during ${singularTerm}.`
    },
    tags: {
      label: 'Product Tag Restrictions',
      description: `Exclude specific products from your ${singularTerm} catalog by adding their product tags here. Products with these tags won't appear in the ${singularTerm} options. Note: Tag restrictions override other settings if conflicts occur.`
    },
    price: {
      label: 'Price Restrictions',
      description: `Set a price threshold to exclude products and variants below this amount from your ${singularTerm} catalog. ShipStation Returns syncs with your store to automatically update these exclusions.`
    },
    digitalProducts: {
      label: 'Include Digital Products',
      description: `This will display Gift Cards or similar items in the ${singularTerm} catalog.`
    },
    saleItems: {
      label: 'Show Sale Items',
      description: (
        <span>
          Choose this option to exclude items that have been marked for sale. We
          will sync all product & variants that have{' '}
          <code>compare_at_price</code> value that is above the{' '}
          <code>listed price</code>.
        </span>
      )
    }
  };
}
